import { render, staticRenderFns } from "./TransferIntoIndex.vue?vue&type=template&id=005dcd98&scoped=true&"
import script from "./TransferIntoIndex.vue?vue&type=script&lang=ts&"
export * from "./TransferIntoIndex.vue?vue&type=script&lang=ts&"
import style0 from "./TransferIntoIndex.vue?vue&type=style&index=0&id=005dcd98&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005dcd98",
  null
  
)

export default component.exports